import React, { useEffect } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { LineChartOptions } from './types';

const getTooltipFormatter = (categories?: Array<string | number | null | undefined>): Highcharts.TooltipFormatterCallbackFunction =>
  function tooltipFormatter(this: Highcharts.TooltipFormatterContextObject) {
    const pointIndex = this.point?.index ?? 0;
    const xValue = categories?.[pointIndex] ?? this.x;
    const rawY = typeof this.y === 'number' ? this.y : 0;
    const yValue = rawY < 0 ? 0 : rawY;
    const pointText = yValue === 1 ? 'Point' : 'Points';

    return `${xValue}: ${yValue} ${pointText}`;
  };

const LineChart = ({ title, xAxis, yAxis, data, modifiedTooltip }: LineChartOptions) => {
  const [tickInterval, setTickInterval] = React.useState(10);

  useEffect(() => {
    const dataMin = Math.min(...data);
    const dataMax = Math.max(...data);
    const interval = Math.ceil((dataMax - dataMin) / 10);
    const roundedTickInterval = Math.ceil(interval / 10) * 10;

    setTickInterval(roundedTickInterval);
  }, [data]);

  const options: Highcharts.Options = {
    chart: {
      height: 390,
      width: 490,
      style: {
        fontFamily: 'Inter',
        fontSize: '14.137px',
        fontWeight: '500',
        color: '#838383',
      },
    },
    tooltip: modifiedTooltip
      ? {
          formatter: getTooltipFormatter(xAxis?.categories),
        }
      : {},
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    title: {
      text: title,
    },
    xAxis: {
      labels: {
        style: {
          color: '#838383',
          textAlign: 'center',
          fontFamily: 'Inter',
          fontSize: '14.137px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: 'normal',
        },
      },
      categories: xAxis?.categories,
    },
    yAxis: {
      labels: {
        style: {
          color: '#000',
          textAlign: 'right',
          fontFamily: 'Inter',
          fontSize: '15.309px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '19.811px',
        },
      },
      title: {
        text: yAxis?.title?.text,
      },
      tickInterval,
    },
    series: [
      {
        type: 'line',
        name: '',
        data: data?.map((value, index) => [xAxis?.categories[index], value]) || [],
        color: '#2559C3',
        marker: {
          fillColor: '#FFFFFF',
          lineWidth: 2,
          lineColor: '#2559C3', // inherit from series
        },
      },
    ],
  };

  return (
    <div className="score-chart-inner-wrap">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

LineChart.defaultProps = {
  xAxis: {
    categories: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  },
  yAxis: {
    title: {
      text: 'Value',
    },
  },
  data: [1, 3, 2, 4, 5, 7, 6, 8, 9, 10, 8, 7],
};

export default LineChart;
